import React from "react";
import { ErrorMessage, Field } from "formik";
import TextField from "@mui/material/TextField";

interface FieldProps {
  value?: string;
  name: string;
  label: string;
  err: any;
  variant?: string;
  required?: boolean;
  multiline?: boolean;
  rows?: number;
  onKey?: any;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  type?: string;
  step?: string;
  min?: string;
  max?: string;
  disabled?: boolean;
  placeholder?: string;
}

const FormikField: React.FC<FieldProps> = ({
  value,
  name,
  label,
  err,
  variant,
  required = false,
  multiline = false,
  rows,
  onKey,
  onChange,
  type= 'text',
  step,
  disabled,
  placeholder,
}) => {
  return (
    <div>
      <Field
        value={value}
        as={TextField}
        label={label}
        name={name}
        fullWidth
        helperText={<ErrorMessage name={`${name}`} />}
        error={err}
        variant={variant}
        autoComplete="off"
        required={required}
        multiline={multiline}
        rows={rows}
        onKeyPress={onKey}
        type={type}
        placeholder={placeholder}
        inputProps={{
          step: `${step}`,
        }}
        {...(onChange ? { onChange } : {})}
      />
    </div>
  );
};

export default FormikField;
